<template>
  <iTextArea
    v-model="value"
    :width="getOptionValue(LayoutWidth)"
    :label="labelValue"
    :placeholder="placeholderValue"
    :rows="rowsValue"
    :style-overrides="inputStyleOverrides"
    @blur="commitOnBlur"
  />
</template>

<script>
import { plainLabelText } from "%/dynamic-component-editor/helpers/plain-label-text.mjs";
import { DynamicElementMixin } from "%/dynamic-component-editor/mixins/dynamic-element-mixin";
import DynamicElementWithContext from "%/dynamic-component-editor/mixins/dynamic-element-with-context-mixin";
import DynamicAppInputOptionsMixin from "%/dynamic-component-editor/standard-elements/dynamic-app-elements/inputs/dynamic-app-input-options-mixin";
import LayoutWidth from "%/dynamic-component-editor/options/layout-width";
import CommitAction from "%/dynamic-component-editor/options/commit-action";
import SeedField from "%/dynamic-component-editor/options/seed-field";
import Placeholder from "%/dynamic-component-editor/options/placeholder";
import Label from "%/dynamic-component-editor/options/label";
import InputRows from "%/dynamic-component-editor/options/input-rows";
import LayoutWidthHeightOptions from "%/dynamic-component-editor/bundles/layout-width-height-options";
import BasicTextOptions from "%/dynamic-component-editor/bundles/basic-text-options";
import SpacingOptions from "%/dynamic-component-editor/bundles/spacing-options";
import AppearanceOptions from "%/dynamic-component-editor/bundles/appearance-options";
import BackgroundColor from "%/dynamic-component-editor/options/background-color";
import BorderColor from "%/dynamic-component-editor/options/border-color";
import BorderWidth from "%/dynamic-component-editor/options/border-width";

const MIN_ROWS = 1;

export default {
  name: "DynamicAppTextAreaInputElement",
  mixins: [DynamicElementMixin, DynamicElementWithContext, DynamicAppInputOptionsMixin],
  elementPanelSettings: {
    displayName: "Text Area",
    elementGroup: "general",
    displayIcon: "pencil",
    elementType: "element",
  },
  hidden: true,
  options: [
    CommitAction,
    SeedField,
    Placeholder,
    Label,
    InputRows,
    BackgroundColor,
    BorderColor,
    BorderWidth,
  ],
  optionBundles: [
    new BasicTextOptions({}, {
      "font-family": true,
    }),
    new LayoutWidthHeightOptions({}, {
      "layout-height": true,
      "max-width": true,
      "max-height": true,
      "min-width": true,
      "min-height": true,
    }),
    new SpacingOptions(),
    new AppearanceOptions({}, {
      "border-radius": false,
    }),
  ],
  computed: {
    LayoutWidth() {
      return LayoutWidth;
    },
    placeholderValue() {
      return this.appInputResolvedValue(this.getOptionValue(Placeholder)) ?? "";
    },
    labelValue() {
      return plainLabelText(this.getOptionValue(Label));
    },
    rowsValue() {
      const rows = Number(this.getOptionValue(InputRows));
      return Number.isFinite(rows) && rows >= MIN_ROWS ? Math.round(rows) : InputRows.defaultValue;
    },
    inputStyleOverrides() {
      const padding = this.appInputPadding;
      return this.appInputStyleOverrides({
        borderRadius: this.appInputBorderRadius,
        inputBorderRadius: this.appInputBorderRadius,
        inputBorderFocusRadius: this.appInputBorderRadius,
        inputBackgroundColor: this.appInputBackgroundColor,
        inputBorderColor: this.appInputBorderColor,
        inputBorderWidth: this.appInputBorderWidth,
        inputFontColor: this.appInputFontColor,
        inputFontWeight: this.appInputFontWeight,
        inputFontSize: this.appInputFontSize,
        inputPaddingTop: padding.top ?? null,
        inputPaddingBottom: padding.bottom ?? null,
        inputPaddingLeft: padding.left ?? null,
        inputPaddingRight: padding.right ?? null,
      });
    },
    value: {
      get() {
        const draft = this.valueFromContext;
        if (draft === null || draft === undefined || draft === "") {
          return this.appInputSeededValue;
        }
        return draft;
      },
      set(value) {
        if (!this.editMode) {
          this.valueFromContext = value;
        }
      },
    },
  },
  methods: {
    async commitOnBlur() {
      await this.$nextTick();
      this.triggerNamedAction(this.getOptionValue(CommitAction));
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
